import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const UserBannedTooltip = ({ children, show }) => {
    if (!show) {
        return children
    }

    return (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip id="tooltip-user-banned">You are banned from this facility</Tooltip>
            }
        >
            {children}
        </OverlayTrigger>
    )
}

export default UserBannedTooltip
